import { useCallback, useState } from 'react'
import { useAuth } from '../contexts/AuthContext'

// Session-scoped flag that gates the per-video rotation / force-vertical
// controls. These controls change how each video is rendered on the live feed
// shown on screens by the desktop playback app, so they stay hidden until an
// authorized admin explicitly enables them (with a confirmation modal).
const STORAGE_KEY = 'crowds_video_display_controls'

const CONTROL_ROLES = ['eventadmin', 'moderator']

function readStored() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export function useVideoDisplayControls(eventId) {
  const { isSysAdmin, eventRoles } = useAuth()

  // sysadmins, plus event-scoped eventadmins / moderators
  const canControl =
    isSysAdmin ||
    (eventRoles || []).some(
      (r) => r.eventid === eventId && CONTROL_ROLES.includes(r.role)
    )

  const [enabled, setEnabledState] = useState(readStored)

  const setEnabled = useCallback((value) => {
    setEnabledState(value)
    try {
      sessionStorage.setItem(STORAGE_KEY, String(value))
    } catch {
      /* ignore storage failures */
    }
  }, [])

  return {
    canControl,
    enabled,
    setEnabled,
    // controls are only live when the user may use them AND has turned them on
    active: canControl && enabled,
  }
}
